<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && aprovacao">
      <px-aprovacao-solicitacao-detalhes-dados-basicos :aprovacao="aprovacao"
                                                       @update="onUpdate"/>
      <px-aprovacao-solicitacao-detalhes-produtos :aprovacao="aprovacao"
                                                  @update="onUpdate"/>
      <px-aprovacao-solicitacao-detalhes-fornecedores :aprovacao="aprovacao"/>
      <px-aprovacao-solicitacao-detalhes-links :aprovacao="aprovacao"/>
    </div>
  </div>
</template>

<script>
import AprovacaoSolicitacaoDetalhesDadosBasicos
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesDadosBasicos.vue';
import AprovacaoSolicitacaoDetalhesFornecedores
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesFornecedores.vue';
import AprovacaoSolicitacaoDetalhesProdutos
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesProdutos.vue';
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';
import AprovacaoSolicitacaoDetalhesLinks
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesLinks.vue';

export default {
  props: {
    aprovacaoIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      aprovacaoId: null,
      aprovacao: null,
    };
  },
  methods: {
    getAprovacao() {
      this.loading = true;
      AprovacaoSolicitacaoService.get(this.aprovacaoId)
        .then(({ data }) => {
          this.aprovacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
      this.getAprovacao();
    },
  },
  created() {
    this.aprovacaoId = this.aprovacaoIdProp || this.$route.params.id;
    this.getAprovacao();
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesDadosBasicos: AprovacaoSolicitacaoDetalhesDadosBasicos,
    pxAprovacaoSolicitacaoDetalhesFornecedores: AprovacaoSolicitacaoDetalhesFornecedores,
    pxAprovacaoSolicitacaoDetalhesProdutos: AprovacaoSolicitacaoDetalhesProdutos,
    pxAprovacaoSolicitacaoDetalhesLinks: AprovacaoSolicitacaoDetalhesLinks,
  },
};
</script>
